export enum SCAN_STATUS {
    IN_PROGRESS = 'running',
    FINISHED = 'ready',
}

export const SCAN_DEFAULT_ESTIMATION = 120;
export const SCAN_DEFAULT_ESTIMATION_ONE_DAY = 10;
